import { fetchUomByIdSuccess, fetchUomByIdFailure } from "./reducer"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_UOM_BY__ID_API } from '../../constants/constants'

export const getUomById = (setLoading, uomName, setInitialValues, ValueTypeOptions, RoundingRuleOptions) => (dispatch) => {
    setLoading(true);
    determineBaseUrlAndPerformApiCall(`${GET_UOM_BY__ID_API}/${uomName}`, 'GET')
        .then((response) => {
            setLoading(false);
            dispatch(fetchUomByIdSuccess(response));
            
            // Find the matching value type option
            const matchingValueType = ValueTypeOptions.find(attr => 
                attr.name === 'valuetype'
            )?.options?.find(option => 
                option.value === response.valueType
            );
            
            // Find the matching rounding rule option
            const matchingRoundingRule = RoundingRuleOptions.find(attr => 
                attr.name === 'roundingRule'
            )?.options?.find(option => 
                option.value === response.roundingRule
            );
            
            // Set initial values with the fetched data
            setInitialValues({
                name: response.name || "",
                valuetype: matchingValueType || "",
                stepQuantity: response.stepQuantity || "",
                roundingRule: matchingRoundingRule || "",
            });
        })
        .catch((errorResp) => { 
            setLoading(false);
            dispatch(fetchUomByIdFailure(errorResp.message)); 
        });
}